"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactProvider = require("@trycourier/react-provider");

var _clientGraphql = require("@trycourier/client-graphql");

var _init = require("./actions/init");

var _markAllRead = require("./actions/mark-all-read");

var _markMessageArchived3 = require("./actions/mark-message-archived");

var _markMessageRead3 = require("./actions/mark-message-read");

var _markMessageUnread3 = require("./actions/mark-message-unread");

var _resetLastFetched2 = require("./actions/reset-last-fetched");

var _setView2 = require("./actions/set-view");

var _toggleInbox2 = require("./actions/toggle-inbox");

var _unpinMessage3 = require("./actions/unpin-message");

var _addTag3 = require("./actions/add-tag");

var _removeTag3 = require("./actions/remove-tag");

var _react = require("react");

var _markMessageOpened3 = require("./actions/mark-message-opened");

var _newMessage2 = require("./actions/new-message");

var _middleware = _interopRequireDefault(require("./middleware"));

var _reducer = _interopRequireDefault(require("./reducer"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useInboxActions = function useInboxActions() {
  var _inbox$messages, _inbox$pinned;

  var _useCourier = (0, _reactProvider.useCourier)(),
      apiUrl = _useCourier.apiUrl,
      authorization = _useCourier.authorization,
      clientKey = _useCourier.clientKey,
      clientSourceId = _useCourier.clientSourceId,
      dispatch = _useCourier.dispatch,
      inbox = _useCourier.inbox,
      inboxApiUrl = _useCourier.inboxApiUrl,
      tenantId = _useCourier.tenantId,
      userId = _useCourier.userId,
      userSignature = _useCourier.userSignature;

  var clientParams = {
    apiUrl: apiUrl,
    authorization: authorization,
    clientKey: clientKey,
    clientSourceId: clientSourceId,
    tenantId: tenantId,
    userId: userId,
    userSignature: userSignature
  };
  var inboxClient = (0, _clientGraphql.Inbox)(_objectSpread(_objectSpread({}, clientParams), {}, {
    apiUrl: inboxApiUrl
  }));
  (0, _react.useEffect)(function () {
    var inboxMiddleware = (0, _middleware["default"])({
      inboxClient: inboxClient
    });
    (0, _reactProvider.registerReducer)("inbox", _reducer["default"]);
    (0, _reactProvider.registerMiddleware)("inbox", inboxMiddleware);
  }, []);
  var onEvent = inbox === null || inbox === void 0 ? void 0 : inbox.onEvent;
  var allMessages = [].concat((0, _toConsumableArray2["default"])((_inbox$messages = inbox === null || inbox === void 0 ? void 0 : inbox.messages) !== null && _inbox$messages !== void 0 ? _inbox$messages : []), (0, _toConsumableArray2["default"])((_inbox$pinned = inbox === null || inbox === void 0 ? void 0 : inbox.pinned) !== null && _inbox$pinned !== void 0 ? _inbox$pinned : []));

  var handleGetUnreadMessageCount = function handleGetUnreadMessageCount(params) {
    dispatch({
      type: "inbox/FETCH_UNREAD_MESSAGE_COUNT",
      payload: function payload() {
        return inboxClient.getInboxCount({
          from: (params === null || params === void 0 ? void 0 : params.from) || (inbox === null || inbox === void 0 ? void 0 : inbox.from),
          status: "unread",
          tenantId: tenantId || (params === null || params === void 0 ? void 0 : params.tenantId) || (inbox === null || inbox === void 0 ? void 0 : inbox.tenantId)
        });
      }
    });
  };

  var handleInit = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(payload) {
      var searchParams, meta;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch((0, _init.initInbox)(payload));
              handleGetUnreadMessageCount();

              if (payload !== null && payload !== void 0 && payload.isOpen || inbox !== null && inbox !== void 0 && inbox.isOpen) {
                searchParams = {
                  from: inbox === null || inbox === void 0 ? void 0 : inbox.from
                };
                meta = {
                  searchParams: searchParams
                };
                dispatch({
                  type: "inbox/FETCH_MESSAGES",
                  meta: meta,
                  payload: function payload() {
                    return inboxClient.getMessages(meta.searchParams);
                  }
                });
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleInit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    init: handleInit,
    resetLastFetched: function resetLastFetched() {
      dispatch((0, _resetLastFetched2.resetLastFetched)());
    },
    toggleInbox: function toggleInbox(isOpen) {
      dispatch((0, _toggleInbox2.toggleInbox)(isOpen));
    },
    setView: function setView(view) {
      dispatch((0, _setView2.setView)(view));
    },
    fetchMessages: function fetchMessages(_payload) {
      var _payload$params;

      var searchParams = _objectSpread(_objectSpread({}, _payload === null || _payload === void 0 ? void 0 : _payload.params), {}, {
        status: _payload === null || _payload === void 0 ? void 0 : (_payload$params = _payload.params) === null || _payload$params === void 0 ? void 0 : _payload$params.status,
        from: inbox === null || inbox === void 0 ? void 0 : inbox.from
      });

      if (typeof searchParams.isRead !== "undefined") {
        delete searchParams.isRead;
      }

      var meta = {
        searchParams: searchParams
      };
      dispatch({
        meta: meta,
        payload: function payload() {
          return inboxClient.getMessages(searchParams, _payload === null || _payload === void 0 ? void 0 : _payload.after);
        },
        type: "inbox/FETCH_MESSAGES"
      });
    },
    getUnreadMessageCount: handleGetUnreadMessageCount,
    markAllAsRead: function () {
      var _markAllAsRead = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(fromWS) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch((0, _markAllRead.markAllRead)());

                if (fromWS) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return inboxClient.markAllRead();

              case 4:
                if (onEvent) {
                  onEvent({
                    event: "mark-all-read"
                  });
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function markAllAsRead(_x2) {
        return _markAllAsRead.apply(this, arguments);
      }

      return markAllAsRead;
    }(),
    trackClick: function () {
      var _trackClick = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(messageId, trackingId) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return inboxClient.trackClick(messageId, {
                  trackingId: trackingId
                });

              case 2:
                if (onEvent) {
                  onEvent({
                    messageId: messageId,
                    message: allMessages.find(function (m) {
                      return m.messageId === messageId;
                    }),
                    event: "click"
                  });
                }

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function trackClick(_x3, _x4) {
        return _trackClick.apply(this, arguments);
      }

      return trackClick;
    }(),
    markMessageRead: function () {
      var _markMessageRead2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(messageId, fromWS) {
        var message;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                message = allMessages.find(function (m) {
                  return m.messageId === messageId;
                });

                if (!(message !== null && message !== void 0 && message.read)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                dispatch((0, _markMessageRead3.markMessageRead)(messageId));

                if (fromWS) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 7;
                return inboxClient.markRead(messageId);

              case 7:
                if (onEvent) {
                  onEvent({
                    event: "read",
                    message: message,
                    messageId: messageId
                  });
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function markMessageRead(_x5, _x6) {
        return _markMessageRead2.apply(this, arguments);
      }

      return markMessageRead;
    }(),
    markMessageUnread: function () {
      var _markMessageUnread2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(messageId, fromWS) {
        var message;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                message = allMessages.find(function (m) {
                  return m.messageId === messageId;
                });

                if (message !== null && message !== void 0 && message.read) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                dispatch((0, _markMessageUnread3.markMessageUnread)(messageId));

                if (fromWS) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 7;
                return inboxClient.markUnread(messageId);

              case 7:
                if (onEvent) {
                  onEvent({
                    messageId: messageId,
                    message: message,
                    event: "unread"
                  });
                }

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function markMessageUnread(_x7, _x8) {
        return _markMessageUnread2.apply(this, arguments);
      }

      return markMessageUnread;
    }(),
    markMessageOpened: function () {
      var _markMessageOpened2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(messageId, fromWS) {
        var message;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                message = allMessages.find(function (m) {
                  return m.messageId === messageId;
                });

                if (!(message !== null && message !== void 0 && message.opened)) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                dispatch((0, _markMessageOpened3.markMessageOpened)(messageId));

                if (fromWS) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 7;
                return inboxClient.markOpened(messageId);

              case 7:
                if (onEvent) {
                  onEvent({
                    messageId: messageId,
                    message: message,
                    event: "opened"
                  });
                }

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function markMessageOpened(_x9, _x10) {
        return _markMessageOpened2.apply(this, arguments);
      }

      return markMessageOpened;
    }(),
    markMessageArchived: function () {
      var _markMessageArchived2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(messageId, fromWS) {
        var _inbox$messages$lengt, _inbox$messages2;

        var message, messageLength;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                message = allMessages.find(function (m) {
                  return m.messageId === messageId;
                });

                if (!(message !== null && message !== void 0 && message.archived)) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return");

              case 3:
                dispatch((0, _markMessageArchived3.markMessageArchived)(messageId));

                if (fromWS) {
                  _context7.next = 7;
                  break;
                }

                _context7.next = 7;
                return inboxClient.markArchive(messageId);

              case 7:
                if (onEvent) {
                  onEvent({
                    messageId: messageId,
                    message: message,
                    event: "archive"
                  });
                }

                messageLength = (_inbox$messages$lengt = inbox === null || inbox === void 0 ? void 0 : (_inbox$messages2 = inbox.messages) === null || _inbox$messages2 === void 0 ? void 0 : _inbox$messages2.length) !== null && _inbox$messages$lengt !== void 0 ? _inbox$messages$lengt : 0;

                if (messageLength <= 1 && inbox.searchParams) {
                  dispatch({
                    meta: {
                      searchParams: inbox.searchParams
                    },
                    payload: function payload() {
                      return inboxClient.getMessages(inbox.searchParams);
                    },
                    type: "inbox/FETCH_MESSAGES"
                  });
                }

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function markMessageArchived(_x11, _x12) {
        return _markMessageArchived2.apply(this, arguments);
      }

      return markMessageArchived;
    }(),
    addTag: function () {
      var _addTag2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(messageId, tag, fromWS) {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                dispatch((0, _addTag3.addTag)(messageId, tag));

                if (fromWS) {
                  _context8.next = 4;
                  break;
                }

                _context8.next = 4;
                return inboxClient.addTag(messageId, {
                  tag: tag
                });

              case 4:
                if (onEvent) {
                  onEvent({
                    event: "add-tag",
                    message: allMessages.find(function (m) {
                      return m.messageId === messageId;
                    }),
                    messageId: messageId,
                    data: {
                      tag: tag
                    }
                  });
                }

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function addTag(_x13, _x14, _x15) {
        return _addTag2.apply(this, arguments);
      }

      return addTag;
    }(),
    removeTag: function () {
      var _removeTag2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(messageId, tag, fromWS) {
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                dispatch((0, _removeTag3.removeTag)(messageId, tag));

                if (fromWS) {
                  _context9.next = 4;
                  break;
                }

                _context9.next = 4;
                return inboxClient.removeTag(messageId, {
                  tag: tag
                });

              case 4:
                if (onEvent) {
                  onEvent({
                    event: "remove-tag",
                    message: allMessages.find(function (m) {
                      return m.messageId === messageId;
                    }),
                    messageId: messageId,
                    data: {
                      tag: tag
                    }
                  });
                }

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function removeTag(_x16, _x17, _x18) {
        return _removeTag2.apply(this, arguments);
      }

      return removeTag;
    }(),
    unpinMessage: function () {
      var _unpinMessage2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(messageId, fromWS) {
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                dispatch((0, _unpinMessage3.unpinMessage)(messageId));

                if (fromWS) {
                  _context10.next = 4;
                  break;
                }

                _context10.next = 4;
                return inboxClient.unpinMessage(messageId);

              case 4:
                if (onEvent) {
                  onEvent({
                    messageId: messageId,
                    message: allMessages.find(function (m) {
                      return m.messageId === messageId;
                    }),
                    event: "unpin"
                  });
                }

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function unpinMessage(_x19, _x20) {
        return _unpinMessage2.apply(this, arguments);
      }

      return unpinMessage;
    }(),
    newMessage: function newMessage(message) {
      dispatch((0, _newMessage2.newMessage)(message));
    }
  };
};

var _default = useInboxActions;
exports["default"] = _default;